import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { activityService } from '../services/api/activity.service';

const PAGE_TITLES: Record<string, string> = {
  '/dashboard/overview': 'Overview',
  '/dashboard/feedback': 'Unified Feedback',
  '/dashboard/analytics': 'Analytics',
  '/dashboard/conversations': 'Instagram DM',
  '/dashboard/google-reviews': 'Google Reviews',
  '/dashboard/guest-comment-cards': 'Guest Comment Cards',
  '/dashboard/templates': 'Template Management',
  '/dashboard/developer-feedback': 'Developer Feedback',
  '/dashboard/user-management': 'User Management',
  '/dashboard/outlet-management': 'Outlet Management',
  '/dashboard/brand-management': 'Brand Management',
  '/dashboard/crawl-management': 'Crawl Management',
  '/dashboard/user-activity': 'User Activity',
};

/**
 * Logs dashboard page navigation for authenticated users.
 */
const NavigationLogger: React.FC = () => {
  const location = useLocation();
  const previousPath = useRef<string | null>(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token || !location.pathname.startsWith('/dashboard')) {
      return;
    }

    if (previousPath.current === location.pathname) {
      return;
    }

    const referrer = previousPath.current || document.referrer;
    previousPath.current = location.pathname;

    const pageTitle = PAGE_TITLES[location.pathname] || document.title;

    activityService.logNavigation(location.pathname, pageTitle, referrer).catch(() => {
      // Non-blocking — navigation logging should not affect UX
    });
  }, [location.pathname]);

  return null;
};

export default NavigationLogger;
